import { useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import SkorProtectShield from "../../assets/img/skor-protect-shield.png";
import CheckCircleIcon from "../SkorProtectSelector/CheckCircleIcon";
import { Tooltip as ReactTooltip } from "react-tooltip";
import axiosInstance from "../../services/authWrapper";
import { toast } from "../../helper/common";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { Button } from "../design";

const SkorProtectConfirmModal = ({ isOpen, onClose, onConfirmed }) => {
  const { _t } = useTranslator();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const userId = localStorage.getItem("saveduserid");
      await axiosInstance.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/profile/${userId}`,
        { skor_protect: true, is_edit: true },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      toast.success(_t("skorProtectEnabled", "Skor Protect enabled"));
      onConfirmed?.();
      onClose();
    } catch {
      toast.error(
        _t("failedToEnableSkorProtect", "Failed to enable Skor Protect")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="newmodalui wrapper-modal inviteTenantModal max-w-lg awardInsuranceConfirmModal"
    >
      <Modal.Header>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img
            src={SkorProtectShield}
            alt=""
            style={{ width: 28, height: 28 }}
          />
          <h2 className="aic-title" style={{ margin: 0 }}>
            {_t("skorProtectTitle")}
          </h2>
          <span className="sp-badge">{_t("recommended")}</span>
        </div>
        <div className="cursor-pointer" onClick={onClose}>
          <img src={Cancelimg} alt="close" className="canceicon topRightIcon" />
        </div>
      </Modal.Header>

      <Modal.Body>
        <div
          style={{
            border: "1px solid var(--line)",
            borderRadius: "var(--radius-lg)",
            padding: 20,
            marginTop: 12,
            display: "flex",
            flexDirection: "column",
            gap: 14,
          }}
        >
          <p className="sp-desc" style={{ margin: 0 }}>
            {_t("skorProtectDesc")}
          </p>

          <ul className="sp-benefits" style={{ margin: 0 }}>
            <li>
              <CheckCircleIcon />
              <span>
                <strong>{_t("skorBenefit1Bold")}</strong>
                {" - "}
                {_t("skorBenefit1Rest")}
              </span>
            </li>
            <li>
              <CheckCircleIcon />
              <span>
                <strong>{_t("skorBenefit2Bold")}</strong>
                {" - "}
                {_t("skorBenefit2Rest")}
              </span>
            </li>
            <li>
              <CheckCircleIcon />
              <span>
                <strong>{_t("skorBenefit3Bold")}</strong>
                {" - "}
                {_t("skorBenefit3Rest")}
              </span>
            </li>
          </ul>

          <p className="sp-pricing" style={{ margin: 0 }}>
            {_t("skorNoChargeNow")}
            {" · "}
            <span
              className="sp-pricing-trigger"
              data-tooltip-id="skor-protect-confirm-price-tooltip"
            >
              {_t("skorPriceConfirmed")}
            </span>
          </p>
          <ReactTooltip
            id="skor-protect-confirm-price-tooltip"
            place="top"
            noArrow
            className="react-tooltip-styling sp-price-tooltip"
            render={() => (
              <span className="sp-price-tooltip-text">
                {_t("skorPriceTooltip")}
              </span>
            )}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="aic-footer skor-protect-footer">
        <Button
          variant="secondary"
          size="lg"
          onClick={onClose}
          disabled={loading}
          type="button"
        >
          {_t("cancel", "Cancel")}
        </Button>
        <Button
          variant="primary"
          size="lg"
          onClick={handleConfirm}
          disabled={loading}
          type="button"
        >
          {loading ? _t("enabling", "Enabling...") : _t("confirm", "Confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SkorProtectConfirmModal;
